import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import {UserForm} from "./UserForm";

function initUsersCreate() {

	// Create instance of form
	const userForm = new UserForm({
		formElement: document.querySelector('.user-form'),
	});

	document.querySelector('.create-new-user-button').onclick = createNewUser;

	/** Methods */

	function createNewUser() {
		// Display loading overlay
		loading()

		// Let form take care of submission and error handling...
		userForm.submit()
			//... display success message and redirect if requested by the server
			.then(handleAjaxSuccess)
			.finally(stopLoading);
	}
}

export {initUsersCreate}
